import { BotFilesLocal } from "./files/BotFiles";

const ImportExport = (props) => <BotFilesLocal className="mb-0" />;

export default ImportExport;
